<main class="audit-log-page">
  <section class="audit-log-card" aria-labelledby="audit_log_title">
    <header class="audit-log-card__header">
      <h2 id="audit_log_title" class="audit-log-card__title">Audit log</h2>
      <span class="audit-log-card__range">LAST 50 EVENTS</span>
    </header>

    <ol class="audit-log-timeline">
      <li
        v-for="event in audit_events"
        :key="`${event.title}-${event.time}`"
        :class="['audit-log-timeline__item', `audit-log-timeline__item--${event.tone}`]"
      >
        <span :class="['audit-log-timeline__marker', marker_class(event.tone)]" aria-hidden="true">
          <i :class="['bi', event.icon]"></i>
        </span>

        <div class="audit-log-timeline__content">
          <h3 class="audit-log-timeline__title">{{ event.title }}</h3>
          <p class="audit-log-timeline__meta">
            <i class="bi bi-person" aria-hidden="true"></i>
            <span>{{ event.actor }}</span>
            <span aria-hidden="true">·</span>
            <span>{{ event.date }}</span>
            <span aria-hidden="true">·</span>
            <span>{{ event.time }}</span>
          </p>
        </div>
      </li>
    </ol>
  </section>
</main>
